const validateNumber = (value) => {
  const validNumber = /^[0-9]*$/;
  const validLength = 2;
  return !value || (value.match(validNumber) && value.length <= validLength)
    ? true
    : false;
};

export default validateNumber;
